<template>
    <div class="content__body">
        <div class="profile-info">
            <div class="profile-info__header">
                <div>Информация о профиле синхронизирована с системой Hyundai ID.</div>
                <div>Если вы нашли ошибку или хотите изменить свои данные — обратитесь к администратору системы.</div>
            </div>

            <div class="profile-info__body">
                <div class="profile-info__body-row">
                    <div class="profile-info__body-name">ФИО</div>
                    <div class="profile-info__body-value">{{ getCurrentUser().full_name || '-' }}</div>
                </div>

                <div class="profile-info__body-row">
                    <div class="profile-info__body-name">Email</div>
                    <div class="profile-info__body-value">{{ getCurrentUser().email || '-' }}</div>
                </div>

                <div class="profile-info__body-row">
                    <div class="profile-info__body-name">Телефон</div>
                    <div class="profile-info__body-value">{{ getCurrentUser().phone || '-' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import useUserRepository from '@/repositories/user/useUserRepository.ts';

    const { getCurrentUser } = useUserRepository();
</script>
